import React from 'react'
import "./Common_download_btn.css"
import { Link } from 'react-router-dom'

function Common_download_btn({ btnText, disabled = false, Linking, onClick }) {
  return (
    <>
      <div className='Common_download_btn' >
        <button type='button' disabled={disabled} className='common-btn' onClick={onClick}>
          <span>{btnText}</span>
        </button>
      </div>
    </>
  )
}

export default Common_download_btn